module.exports = __webpack_public_path__ + "img/lqupdateicon.3a5f3f36.svg";